import { Box, Card, Container, Typography, Toolbar, Stack } from '@mui/material'
import React from 'react'
import Footer from '../Components/Footer'

export default function Infrastructure() {
    return (
        <React.Fragment>
            <Box >
                <br />
                {/* <Typography variant='h3' component='h3' sx={{ marginLeft: "auto", marginRight: "auto" }}>
                    Infrastructure
                </Typography> */}
                <br />
                <Stack direction={{ xs: "column", md: "row" }}
                    spacing={{ xs: 1, sm: 2, md: 0 }}
                    alignContent={'center'}
                    justifyContent={'center'}
                    alignSelf={'center'}
                    justifyItems={'center'}
                    useFlexGap flexWrap={"initial"}>
                    <Box width={100} />
                    <Box flexGrow={1}>
                        <figure>
                            <img src="images/projectImages/Server.jpg" width={300} />
                            <figcaption>HPCNexus Server</figcaption>
                        </figure>
                    </Box>
                    <Container style={{ textAlign: 'left', wordSpacing: 5, lineHeight: 1.2 }}>
                        <Typography variant="h4">HPCNexus Technical Specifications</Typography>
                        <br />
                        Dell PowerEdge T630 x 2
                        <ul>
                            <li>Processor:</li>
                            <ul>
                                <li>Intel Xeon E5-2600 v3/v4 processor family</li>
                                <li>2 Processor sockets</li>
                                <li>Up to 2 processors, each with up to 18 cores</li>
                            </ul>
                            <ul>
                                <li>Support for up to 32 x 2.5" or 18 x 3.5" hot-plug SAS, SATA, or SSD drives</li>
                                <li>Optional flex bay for up to 4 x 2.5" or 3.5" hot-plug SAS, SATA, or SSD drives</li>
                            </ul>
                            <li>RAID Controllers:</li>
                            <ul>
                                <li>PERC S130, PERC H330, PERC H730, PERC H730P</li>
                                <li>Optional external PERC (RAID): H830</li>
                            </ul>
                            <li>Networking:</li>
                            <ul>
                                <li>4 x 1GbE ports standard</li>
                                <li>4 x 10GbE Ports</li>
                            </ul>
                            <li>Power Supply:</li>
                            <ul>
                                <li>Hot-plug redundant power supply options: 495W, 750W, 1100W, 1600W</li>
                            </ul>
                            <li>Expansion Slots:</li>
                            <ul>
                                <li>Up to 8 PCIe Gen3 slots</li>
                            </ul>
                            <li>Management:</li>
                            <ul>
                                <li>iDRAC8 with Lifecycle Controller (Express, Enterprise)</li>
                                <li>Optional vFlash media reader, iDRAC8 port card</li>
                            </ul>
                            <li>Operating Systems:</li>
                            <ul>
                                <li>Rocky Linux 8.x</li>
                            </ul>
                            <li>Power Meter</li>
                            <ul>
                                <li>OmegaWatt power monitoring system MV2 box is attached with both servers.</li>
                                <li>Measure power consumption of 5 nodes connected to its outputs plugs.</li>
                                <li>Push streams of integrated measurements at rates up to 100Hz</li>
                                <li>System Accuracy: Voltage RMS accuracy is 0.5% (125-250Vrms), Current RMS accuracy is 1% (0.1-10Amps) with 1-second averaging, and Active power accuracy is 1.5% (1-100% of fs) with 1-second averaging.</li>
                            </ul>
                        </ul>
                    </Container>
                    <Container>
                        <img src={"/images/projectImages/Topology.jpg"} width={"100%"} />
                    </Container>
                    <Box width={100} />

                </Stack >
            </Box >
            <Toolbar />
            <Footer />
        </React.Fragment >
    )
}
